import React, { FC } from 'react';
import { Skeleton } from '@mofid-securities/uikit';
import { IBalanceSlideSubComponentProps } from '../../BalanceSlide.types';

interface ICardBalanceSlideCurrencyProps
  extends IBalanceSlideSubComponentProps {}

const CardBalanceSlideCurrency: FC<ICardBalanceSlideCurrencyProps> = ({
  isError,
  isLoading,
}) => (
  <>
    {isLoading ? <Skeleton height={20} width={30} /> : isError ? null : 'ریال'}
  </>
);

export default CardBalanceSlideCurrency;
